import axios from "axios";
import { apiPath, API_URL, REACT_APP_CONTRACT_API_URL } from "./apiPath";
import authHeader from "./authHeader";
const getAgencyApi = (props) => {
  return axios
    .post(API_URL + apiPath.getAgencyList, props, authHeader())
    .then((response) => {
      return response.data;
    });
};

const getItemTypeListApi = (props) => {
  return axios
    .post(API_URL + apiPath.getItemTypeList, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getItemDescriptionAndPriceApi = (props) => {
  return axios
    .post(API_URL + apiPath.getItemDescriptionAndPrice, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getcontractCategoryApi = (props) => {
  return axios
    .post(API_URL + apiPath.getcontractCategory, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const createContractApi = (props) => {
  return axios
    .post(API_URL + apiPath.createContract, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getContractDetailsApi = (props) => {
  return axios
    .post(API_URL + apiPath.getContractDetails, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getContractInvoiceDetailsApi = (props) => {
  return axios
    .post(API_URL + apiPath.getContractInvoiceDetails, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getInvoiceStatusApi = () => {
  return axios
    .get(API_URL + apiPath.getInvoiceStatus, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getInvoiceListApi = (props) => {
  if (props.path) {
    return axios.post(props.path, props, authHeader()).then((response) => {
      return response.data;
    });
  } else {
    return axios
      .post(API_URL + apiPath.getInvoiceList, props, authHeader())
      .then((response) => {
        return response.data;
      });
  }
};
const getContractListApi = (props) => {
  if (props.path) {
    return axios.post(props.path, props, authHeader()).then((response) => {
      return response.data;
    });
  } else {
    return axios
      .post(API_URL + apiPath.getContractList, props, authHeader())
      .then((response) => {
        return response.data;
      });
  }
};

//paymnet apis

const addPaymentApi = (props) => {
  return axios
    .post(API_URL + apiPath.addPayment, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const approvePaymentApi = (props) => {
  return axios
    .post(API_URL + apiPath.approvePayment, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const voidPaymentApi = (props) => {
  return axios
    .post(API_URL + apiPath.voidPayment, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const fetchContractCategoryApi = async (props) => {
  console.log('props', authHeader().headers)
  const response = await axios.get(REACT_APP_CONTRACT_API_URL + apiPath.getcontractCategory, {
    headers: authHeader().headers,
    params: props
  });
  return response.data;
};
const contractApi = {
  getAgencyApi,
  getItemTypeListApi,
  getItemDescriptionAndPriceApi,
  getcontractCategoryApi,
  createContractApi,
  getContractDetailsApi,
  getContractInvoiceDetailsApi,
  getInvoiceListApi,
  getInvoiceStatusApi,
  getContractListApi,
  addPaymentApi,
  approvePaymentApi,
  voidPaymentApi,
  fetchContractCategoryApi
};

export default contractApi;
